<template>
<v-container fluid>
  <h1>Produtos</h1>
  <v-row dense class="products">

    <v-col v-for="(product,i) in products" :key="i" cols="12" md="3" lg="2">
    
      <v-card class="mx-auto product-card">
        
        <v-img class="white--text align-end" width="100%" :src="product.photos[0]">
        </v-img>
  
        <v-card-subtitle class="pb-0">{{product.name}}</v-card-subtitle>
  
        <v-card-text class="text--primary">
          <div>{{product.brand}}</div>
        </v-card-text>
  
        <v-card-actions>
          <v-btn color="orange" text>Favoritar</v-btn>
          <v-btn color="orange" text>Comprar</v-btn>
        </v-card-actions>
      
      </v-card>

    </v-col>

  </v-row>

  <div class="my-2">
    <v-btn color="primary" @click="getMoreProducts" v-intersect="onIntersect">Carregar Mais Produtos</v-btn>
  </div>

</v-container>
</template>

<style>
.products{min-height:1000px;}
.product-card{min-height:200px;}
</style>



<script>

  export default {
    name: 'Products',
    components:{
    },
    data(){
      return {
        pg: 0
      }
    },
    methods:{
      getMoreProducts(){
        this.pg++;
        var opts = {'pg':this.pg};
        this.$store.dispatch('getData',opts);
      },
      onIntersect (entries, observer, isIntersecting) {
          console.log(entries+' '+observer+' '+isIntersecting);
          if(isIntersecting){
            this.getMoreProducts();
            //alert('mais');
          }
      }
    },
    computed:{
      products() {
        return this.$store.state.products;
      }
    },
    mounted(){
      var opts = {'pg':0};
      this.$store.dispatch('getData',opts);
      this.$store.dispatch('bindBrands');
    },   
    created() {
    }
  }
</script>